<template>
    <div
        class="modal fade"
        id="forgotPasswordFormModal"
        data-bs-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content tw-rounded-lg">
                <div class="modal-body" v-show="show_form">
                    <div>
                        <h5 v-if="!show_reset_password_form">
                            {{ __("chat.forgotten_password") }}
                        </h5>
                        <h5 v-if="show_reset_password_form">
                            {{ __("chat.reset_password") }}
                        </h5>
                        <button
                            type="button"
                            class="btn-close tw-opacity-100"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <hr class="tw-mb-4" />
                    <form
                        autocomplete="off"
                        @submit.prevent="onSubmit"
                        v-if="
                            !show_reset_password_form && !success_reset_password
                        "
                    >
                        <div class="row">
                            <div class="col-md-12">
                                <div
                                    class="tw-leading-none tw-mb-3 tw-bg-red-50 tw-rounded-lg tw-p-2 tw-py-3"
                                    v-if="error_message.length > 0"
                                >
                                    <div
                                        class="tw-flex tw-items-center tw-mb-2"
                                    >
                                        <i
                                            class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                                        ></i>
                                        <span
                                            class="tw-text-sm tw-text-red-600"
                                            v-text="error_message"
                                        ></span>
                                    </div>
                                </div>
                                <div
                                    v-show="form.login_type == 'phone'"
                                    class="form-group tw-mb-3"
                                >
                                    <div class="tw-relative">
                                        <div
                                            class="tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-left-3 tw-text-black"
                                        >
                                            <Select2
                                                id="forgotPhoneInput"
                                                v-model="
                                                    form.selected_country_code
                                                "
                                                :options="
                                                    $page.props
                                                        .country_dial_codes
                                                        .codes
                                                "
                                                :settings="{
                                                    templateSelection:
                                                        selectedFormat,
                                                    dropdownParent:
                                                        '#forgotPasswordFormModal .modal-content',
                                                }"
                                                @change="myChangeEvent($event)"
                                                @select="mySelectEvent($event)"
                                            />
                                        </div>
                                        <input
                                            type="text"
                                            class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg forgot-phone-number-input"
                                            :placeholder="
                                                __('chat.phone_number')
                                            "
                                            @keypress="inputValidate"
                                            @focus="
                                                input_errors.phone = '';
                                                show_switch = false;
                                            "
                                            @focusout="show_switch = true"
                                            v-model="form.phone"
                                        />
                                        <span
                                            v-if="show_switch"
                                            @click="form.login_type = 'email'"
                                            v-btooltip:top="__('chat.by_email')"
                                            class="tw-cursor-pointer tw-text-black/50 hover:tw-text-black tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-bg-white tw-px-3 tw-py-1 tw-rounded-lg tw-right-[10px] tw-text-black"
                                        >
                                            <i
                                                class="fas fa-angle-right tw-text-sm"
                                            ></i>
                                            <i
                                                class="fas fa-envelope tw-text-sm"
                                            ></i>
                                        </span>
                                    </div>
                                    <span
                                        class="tw-text-red-500 tw-px-2 tw-text-xs"
                                        v-if="input_errors.phone"
                                        v-text="input_errors.phone[0]"
                                    ></span>
                                </div>
                                <div
                                    v-show="form.login_type == 'email'"
                                    class="form-group tw-mb-3"
                                >
                                    <div class="tw-relative">
                                        <input
                                            type="email"
                                            class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                            :placeholder="
                                                __('chat.email_address')
                                            "
                                            @focus="
                                                input_errors.email = '';
                                                show_switch = false;
                                            "
                                            @focusout="show_switch = true"
                                            v-model="form.email"
                                        />
                                        <span
                                            v-if="show_switch"
                                            @click="form.login_type = 'phone'"
                                            v-btooltip:top="__('chat.by_phone')"
                                            class="tw-cursor-pointer tw-text-black/50 hover:tw-text-black tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-bg-white tw-px-3 tw-py-1 tw-rounded-lg tw-right-[10px] tw-text-black"
                                        >
                                            <i
                                                class="fas fa-angle-right tw-text-sm"
                                            ></i>
                                            <i
                                                class="fas fa-phone tw-text-sm"
                                            ></i>
                                        </span>
                                    </div>
                                    <span
                                        class="tw-text-red-500 tw-px-2 tw-text-xs"
                                        v-if="input_errors.email"
                                        v-text="input_errors.email[0]"
                                    ></span>
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        class="btn tw-h-[45px] tw-w-full btn-md tw-rounded-lg tw-text-white tw-bg-main-color"
                                    >
                                        <BeatLoader
                                            v-if="submitting"
                                            :loading="submitting"
                                            color="white"
                                            size="7px"
                                            class="tw-pt-[3px]"
                                        ></BeatLoader>
                                        <span v-else>{{
                                            __("chat.submit")
                                        }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <form
                        autocomplete="off"
                        @submit.prevent="onReset"
                        v-if="
                            show_reset_password_form && !success_reset_password
                        "
                    >
                        <div class="row">
                            <div class="col-md-12">
                                <div class="tw-mb-8">
                                    <p class="tw-text-sm tw-m-0">
                                        Please enter the OTP code to reset the
                                        account password.
                                    </p>
                                    <p
                                        class="tw-mb-3 tw-text-sm"
                                        v-text="otp.otp_text"
                                    ></p>
                                    <p
                                        class="tw-m-0 tw-text-sm tw-text-slate-500"
                                    >
                                        If you don't received or expired OTP -
                                        <span
                                            v-if="otp.otp_interval > 0"
                                            class="tw-text-main-color/60 tw-cursor-not-allowed"
                                            >Resend
                                            <span
                                                v-text="otp.countdown_text"
                                            ></span
                                        ></span>
                                        <span
                                            class="tw-text-main-color tw-cursor-pointer"
                                            v-if="otp.show_resent"
                                            @click="onResendOtp"
                                            >Resend</span
                                        >
                                    </p>
                                </div>
                                <div class="tw-w-full">
                                    <div class="col-md-12 tw-mb-3">
                                        <div
                                            class="tw-leading-none tw-mb-3 tw-bg-red-50 dark:tw-bg-slate-700 tw-rounded-lg tw-p-2 tw-py-3 tw-flex tw-items-center"
                                            v-if="error_message.length > 0"
                                        >
                                            <i
                                                class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                                            ></i>
                                            <span
                                                class="tw-text-sm tw-text-red-600"
                                                v-text="error_message"
                                            ></span>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 tw-text-center tw-mb-3"
                                    >
                                        <input
                                            type="text"
                                            class="form-control tw-p-2 tw-text-center tw-tracking-[15px] tw-rounded-lg placeholder:tw-tracking-normal"
                                            @keypress="otpInputValidate"
                                            v-model="otp.form.otp_code"
                                            placeholder="Enter 6 Digit Code"
                                            @focus="input_errors.otp_code = ''"
                                        />
                                        <span
                                            class="tw-text-red-500 tw-text-xs"
                                            v-if="input_errors.otp_code"
                                            v-text="input_errors.otp_code[0]"
                                        ></span>
                                    </div>
                                    <div
                                        class="col-md-12 tw-text-center tw-mb-3"
                                    >
                                        <input
                                            type="password"
                                            class="form-control tw-p-2 tw-text-center tw-tracking-[15px] tw-rounded-lg placeholder:tw-tracking-normal"
                                            v-model="otp.form.new_password"
                                            placeholder="New Password"
                                            @focus="
                                                input_errors.new_password = ''
                                            "
                                        />
                                        <span
                                            class="tw-text-red-500 tw-text-xs"
                                            v-if="input_errors.new_password"
                                            v-text="
                                                input_errors.new_password[0]
                                            "
                                        ></span>
                                    </div>
                                    <div
                                        class="col-md-12 tw-text-center tw-mb-3"
                                    >
                                        <input
                                            type="password"
                                            class="form-control tw-p-2 tw-text-center tw-tracking-[15px] tw-rounded-lg placeholder:tw-tracking-normal"
                                            v-model="
                                                otp.form
                                                    .new_password_confirmation
                                            "
                                            placeholder="New Password Confirmation"
                                            @focus="
                                                input_errors.new_password_confirmation =
                                                    ''
                                            "
                                        />
                                        <span
                                            class="tw-text-red-500 tw-text-xs"
                                            v-if="
                                                input_errors.new_password_confirmation
                                            "
                                            v-text="
                                                input_errors
                                                    .new_password_confirmation[0]
                                            "
                                        ></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button
                                    type="submit"
                                    :disabled="resetting"
                                    class="btn tw-w-full tw-p-2 tw-bg-main-color tw-rounded-lg tw-text-white"
                                >
                                    <BeatLoader
                                        v-if="resetting"
                                        :loading="resetting"
                                        color="white"
                                        size="7px"
                                        class="tw-pt-[3px]"
                                    ></BeatLoader>
                                    <span v-else>{{
                                        __("chat.reset_password")
                                    }}</span>
                                </button>
                            </div>
                        </div>
                    </form>
                    <div
                        class="tw-text-center tw-my-4"
                        v-if="success_reset_password && success_message.length"
                    >
                        <i
                            class="fas fa-check-circle tw-text-green-500 tw-text-[3.5em] tw-mt-3"
                        ></i>
                        <h4 class="tw-mb-4">{{ __("chat.success") }}</h4>
                        <p class="tw-m-0" v-text="success_message"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import {
    forgotPassword,
    resetPassword,
    resendOtp,
} from "@landing/Services/auth_service";

export default {
    components: { BeatLoader },
    data() {
        return {
            form: {
                email: "",
                phone: "",
                login_type: "email",
                selected_dial_code: "",
                selected_country_code: "",
            },
            show_form: false,
            input_errors: {},
            error_message: "",
            show_switch: true,
            show_reset_password_form: false,
            success_reset_password: false,
            success_message: "",
            submitting: false,
            resetting: false,
            otp: {
                form: {
                    type: "",
                    value: "",
                    otp_code: "",
                    new_password: "",
                    new_password_confirmation: "",
                },
                otp_text: "",
                otp_interval: 0,
                countdown_text: "",
                intervalHandle: null,
                show_resent: false,
            },
        };
    },
    mounted() {
        let vm = this;
        const myModal = document.getElementById("forgotPasswordFormModal");

        myModal.addEventListener("show.bs.modal", function (event) {
            vm.show_form = true;
            vm.form.selected_country_code =
                vm.$page.props.country_dial_codes.current.country_code;
            vm.form.selected_dial_code =
                vm.$page.props.country_dial_codes.current.dial_code;

            setTimeout(() => {
                vm.select2InputStyle(vm.form.selected_dial_code);
            }, 100);
        });

        myModal.addEventListener("hidden.bs.modal", function (e) {
            vm.show_form = false;
            if (vm.otp.intervalHandle) {
                clearInterval(vm.otp.intervalHandle);
            }
            (vm.input_errors = {}), (vm.error_message = "");
            (vm.show_reset_password_form = false), (vm.submitting = false);
            vm.form.email = "";
            vm.form.phone = "";
            vm.otp = {
                form: {
                    type: "",
                    value: "",
                    otp_code: "",
                    new_password: "",
                    new_password_confirmation: "",
                },
                otp_text: "",
                otp_interval: 0,
                countdown_text: "",
                intervalHandle: null,
                show_resent: false,
            };
        });
    },
    methods: {
        selectedFormat() {
            return this.form.selected_dial_code;
        },
        myChangeEvent(val) {
            this.select2InputStyle(val);
        },
        mySelectEvent({ id, text }) {
            const regex = /\((\+\d+)\)/;
            const match = text.match(regex);
            if (match && match.length > 1) {
                this.form.selected_dial_code = match[1];
            }

            this.select2InputStyle(this.form.selected_dial_code);
        },
        select2InputStyle(val) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = "15px Arial";
            var metrics = context.measureText(val);
            let input = document.querySelector(".forgot-phone-number-input");
            input.style.paddingLeft = Math.ceil(metrics.width) + 17 + "px";
        },
        onSubmit() {
            this.submitting = true;
            this.error_message = "";
            forgotPassword(this.form).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200) {
                    this.error_message = this.__("chat.something_wrong");
                } else if (data.status == 200) {
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.show_reset_password_form = true;
                        this.otp.form.type = data.data.type;
                        this.otp.form.value = data.data.value;
                        this.otp.otp_text = data.data.otp_text;
                        this.otp.otp_interval = data.data.otp_interval;
                        this.startCountDown();
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.submitting = false;
                }, 500);
            });
        },
        onReset() {
            this.resetting = true;
            resetPassword(this.otp.form).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200 && data.status != 422) {
                    this.input_errors = {};
                    this.error_message = this.__("chat.something_wrong");
                } else if (data.status == 200) {
                    this.input_errors = {};
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.success_reset_password = true;
                        this.success_message = data.data.message;
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.resetting = false;
                }, 500);
            });
        },
        onResendOtp() {
            resendOtp({
                type: this.otp.form.type,
                value: this.otp.form.value,
            }).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200) {
                    this.error_message = this.__("chat.something_wrong");
                } else if (data.status == 200) {
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.otp.form.type = data.data.type;
                        this.otp.form.value = data.data.value;
                        this.otp.otp_text = data.data.otp_text;
                        this.otp.otp_interval = data.data.otp_interval;
                        this.startCountDown();
                        Vue.$toast.success(
                            this.translate(
                                "Successfully resend OTP code.",
                                "အောင်မြင်စွာ OTP ကုဒ် ပြန်ပို့ပေးလိုက်ပါပြီ"
                            )
                        );
                    } else {
                        this.error_message = data.data.message;
                    }
                }
            });
        },
        inputValidate(evt) {
            var theEvent = evt || window.event;

            if (theEvent.code == "Enter") {
                return;
            }
            // Handle paste
            if (theEvent.type === "paste") {
                key = event.clipboardData.getData("text/plain");
            } else {
                // Handle key press
                var key = theEvent.keyCode || theEvent.which;
                key = String.fromCharCode(key);
            }
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        },
        otpInputValidate(evt) {
            var theEvent = evt || window.event;

            if (theEvent.code == "Enter") {
                return;
            }

            if (this.otp.form.otp_code.length >= 6) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }

            // Handle paste
            if (theEvent.type === "paste") {
                key = event.clipboardData.getData("text/plain");
            } else {
                // Handle key press
                var key = theEvent.keyCode || theEvent.which;
                key = String.fromCharCode(key);
            }
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        },
        tick() {
            // turn the seconds into mm:ss
            var min = Math.floor(this.otp.otp_interval / 60);
            var sec = this.otp.otp_interval - min * 60;

            //add a leading zero (as a string value) if seconds less than 10
            if (sec < 10) {
                sec = "0" + sec;
            }

            // concatenate with colon
            this.otp.countdown_text = "( " + min.toString() + ":" + sec + " )";

            // stop is down to zero
            if (this.otp.otp_interval === 0) {
                this.otp.show_resent = true;
                this.otp.countdown_text = "";
                clearInterval(this.otp.intervalHandle);
                return;
            }

            //subtract from seconds remaining
            this.otp.otp_interval--;
        },
        startCountDown() {
            if (this.otp.otp_interval > 0) {
                this.otp.show_resent = false;

                this.otp.intervalHandle = setInterval(() => {
                    this.tick();
                }, 1000);
            } else {
                this.otp.countdown_text = "";
                this.otp.show_resent = true;
            }
        },
    },
};
</script>
